import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import { ExternalLink } from "@/components/podkit/typography/ExternalLink";
import { Text } from "@/components/podkit/typography/Text";
import { type FC } from "react";

type LoginFooterProps = PropsWithClassName & {
    linkClassName?: string;
};

export const LoginFooter: FC<LoginFooterProps> = ({ className, linkClassName }) => {
    return (
        <Text className={className}>
            By signing in, you agree to our{" "}
            <ExternalLink href="https://ona.com/legal/terms-of-service" className={linkClassName}>
                terms of service
            </ExternalLink>{" "}
            and{" "}
            <ExternalLink href="https://ona.com/legal/privacy-policy" className={linkClassName}>
                privacy policy
            </ExternalLink>
            .
        </Text>
    );
};
